"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = t;
const lang_1 = __importDefault(require("./lang"));
function t(v, ...rest) {
    let output = String(lang_1.default[v] || v);
    rest.forEach((value, idx) => {
        output = output.replace(`$${idx}`, String(value));
    });
    // replace all occurrences of `DOLLAR_SIGN_` with `$`
    rest.forEach(() => {
        output = output.replace('DOLLAR_SIGN_', String('$'));
    });
    return output;
}
;
